export default __webpack_public_path__ + "static/media/Shield of the Kozak Slayer.6603a816.jpg";